var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6006 20.0761L17.0608 16.9236C17.6437 16.5871 17.9346 16.4188 18.1465 16.1834C18.3341 15.9751 18.4759 15.7297 18.5625 15.4632C18.6602 15.1626 18.6602 14.8267 18.6602 14.1568V7.84268C18.6602 7.17277 18.6602 6.83694 18.5625 6.53638C18.4759 6.26982 18.3341 6.02428 18.1465 5.816C17.9355 5.58161 17.6453 5.41405 17.0674 5.08043L11.5996 1.92359C11.0167 1.58706 10.7259 1.41913 10.416 1.35328C10.1419 1.295 9.85843 1.295 9.58427 1.35328C9.27443 1.41914 8.98259 1.58706 8.39971 1.92359L2.93843 5.07666C2.35623 5.41279 2.06535 5.58073 1.85352 5.816C1.66597 6.02428 1.52434 6.26982 1.43773 6.53638C1.33984 6.83765 1.33984 7.17436 1.33984 7.84742V14.1524C1.33984 14.8254 1.33984 15.1619 1.43773 15.4632C1.52434 15.7297 1.66597 15.9751 1.85352 16.1834C2.06548 16.4188 2.35657 16.5871 2.93945 16.9236L8.39971 20.0761C8.98258 20.4126 9.27443 20.5806 9.58427 20.6465C9.85843 20.7047 10.1419 20.7047 10.416 20.6465C10.7259 20.5806 11.0177 20.4126 11.6006 20.0761Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.9998C7 12.6566 8.34315 13.9998 10 13.9998C11.6569 13.9998 13 12.6566 13 10.9998C13 9.34291 11.6569 7.99976 10 7.99976C8.34315 7.99976 7 9.34291 7 10.9998Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagment);
export default __webpack_public_path__ + "static/media/Managment.d6f7887ce5cc598f10c0ac4e39b9cb99.svg";
export { ForwardRef as ReactComponent };